import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useRisClient } from 'hooks/useRisClient';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Language } from '@resideo/web-integration-services-api-client';
import { useCurrentUser } from 'hooks/useCurrentUser';

const LanguageProvider = () => {
  const { isAuthenticated } = useAuth0();

  const { client } = useRisClient();
  const queryClient = useQueryClient();
  const user = useCurrentUser();

  const updateUserLanguage = () => {
    useMutation({
      mutationFn: async () => {
        return client.myUsers.myUsersUpdateMyUserAccount({
          language:
            navigator.language === 'en-US'
              ? ('en' as Language)
              : (navigator.language as Language),
        });
      },
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['myUser'] });
      },
    }).mutate();
  };

  useEffect(() => {
    if (user) {
      if (isAuthenticated && user.language === null) {
        updateUserLanguage();
      }
    }
  }, [isAuthenticated, user]);

  return null;
};

export default LanguageProvider;
